export const imgSrc = (image, upload = false, path = false) => {
    if (path) {
        return "/img/" + path + "/" + image;
    } else {
        return upload ? "/img/upload/" + image : "/img/" + image;
    }
};

export const apiUrl = (uri = "") => {
    return process.env.REACT_APP_ENDPOINT + "/" + uri;
};
